<div class="page-container hello-sign-container" [class.loading]="isLoading">
    <ui-card *ngIf="!isSigned && noAssignment">
        <h2 class="header">{{ 'document.youDoNotHaveASignatureRequestForThisDocument' | translate }}</h2>
        <ui-button type="link" (click)="goBack()">{{ 'document.goBack' | translate }}</ui-button>
    </ui-card>

    <ui-card *ngIf="isSigned">
        <h2 class="header">{{ 'document.youHaveAlreadySignedThisDocument' | translate }}</h2>
        <ui-button type="link" (click)="goToDocuments()">{{ 'document.goToYourDocuments' | translate }}</ui-button>
    </ui-card>
    <div #helloSignContainer class="hello-sign-target"></div>
</div>
